import { Component, OnInit, Input } from '@angular/core';
import { Contact } from '../../contact.model';
import { Observable } from 'rxjs';
import { ContactMessage } from '../../contact-message.model';
import { ContactService } from '../../contact.service';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { UserService } from 'src/app/user/user.service';

@Component({
  selector: 'app-service-contact-conversation-preview',
  templateUrl: './service-contact-conversation-preview.component.html',
  styleUrls: ['./service-contact-conversation-preview.component.scss']
})
export class ServiceContactConversationPreviewComponent implements OnInit {
  @Input() contact: Contact;

  lastMessage$: Observable<ContactMessage>;
  lastMessageTimeFormatted$: Observable<string>;
  userName$: Observable<string>;

  constructor(
    private contactService: ContactService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.lastMessage$ = this.contactService.getLatestContactMessage(
      this.contact.serviceKey,
      this.contact.clientUserKey
    );

    this.lastMessageTimeFormatted$ = this.lastMessage$.pipe(
      map(lastMessage =>
        moment(lastMessage.timeStamp.toDate()).format('HH:mm DD/MM/YY')
      )
    );

    this.userName$ = this.userService
      .getUserDetailsByKey(this.contact.clientUserKey)
      .pipe(map(details => `${details?.firstName} ${details?.lastName}`));
  }
}
